import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../app/store/rootReducers";
import { useState } from "react";
import { Col } from "react-bootstrap";
import { fetchDebugInfo } from "../../../../app/store/debug/actions";
import { setLoader } from "../../../../app/store/ui/actions";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";

export const DebugInfoBff = () => {
  const dispatch = useDispatch();
  const debugDataBff = useSelector((state: AppState) => state.debug.data.bff);
  const [isLogsVisisble, setIsLogVisisble] = useState(true);
  const [isInfoVisisble, setIsInfoVisible] = useState(false);

  if (!debugDataBff) {
    return (<p>'No data for BFF'</p>);
  }

  const { branch, deployedAt, sso, other, logs } = debugDataBff;

  const handleInfoButtonClick = () => {
    setIsInfoVisible(!isInfoVisisble);
  };

  const handleLogButtonClick = () => {
    setIsLogVisisble(!isLogsVisisble);
  };

  const handleRefreshLogsClick = () => {
    dispatch(fetchDebugInfo());
    dispatch(setLoader(true, MiddlewareEntities.DEBUG));
  };

  const joinedLogs = logs.join('\n');

  const handleCopyButtonClick = () => {
    navigator.clipboard.writeText(joinedLogs).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  };

  return (
    <div className="debug-info-om text-16">
      {isInfoVisisble && <div className="row">
        <Col>
          <p>Branch: <strong>{branch}</strong></p>
          <p>Deployed at: <strong>{deployedAt}</strong></p>
          <p>BFF Url: <strong>{process.env.REACT_APP_API_BASE_URL}</strong></p>
        </Col>
        <Col>
          <h4>SSO:</h4>
          {sso.map((item) => {
            return (
              <p key={item.label}> {item.label} <a href={item.endpoint}>{item.endpoint}</a></p>
            );
          })}
        </Col>
        <Col>
          <h4>Other:</h4>
          {other.map((item) => {
            return (
              <p key={item.label}> {item.label} <a href={item.endpoint}>{item.endpoint}</a></p>
            );
          })}
        </Col>
      </div>}
      <button className="btn btn-sm btn-info mb-2" style={{ clear: "both", float: 'right' }} onClick={handleInfoButtonClick}>{isInfoVisisble ? 'Hide Info' : 'Show Info'}</button>
      <div style={{ clear: "both" }}>
        <div className="border-top pt-2 mb-4">
          <button className="btn btn-sm btn-info mb-2" style={{ float: 'right' }} onClick={handleLogButtonClick}>{isLogsVisisble ? 'Hide Log' : 'Show Logs'}</button>
          {isLogsVisisble && <div>
            <button className="btn btn-sm btn-outline-dark mb-2 mr-2 d-block" onClick={handleCopyButtonClick}>Copy Raw</button>
            <button className="btn btn-sm btn-dark mb-2" onClick={handleRefreshLogsClick}>Refresh Logs</button>
          </div>
          }
          {isLogsVisisble && (
            <div style={{ border: '1px solid #aaa', padding: '10px', maxHeight: '500px', overflow: "scroll" }}>
              {logs.map(log => {
                return (<p key={log} style={{ wordWrap: 'break-word' }}>{log}</p>);
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
